import { useLocation } from 'react-router-dom';
import { OrganizationSchema } from './OrganizationSchema';
import { BreadcrumbSchema } from './BreadcrumbSchema';
import { DatasetSchema } from './DatasetSchema';

export function StructuredData() {
  const location = useLocation();
  const isImpactMetricsPage = location.pathname === '/impact-metrics';

  return (
    <>
      <OrganizationSchema />
      <BreadcrumbSchema />
      {isImpactMetricsPage && <DatasetSchema />}
    </>
  );
}
